import { combineReducers } from 'redux';

import activities from './activitiesReducer';
import contactUsFlow from './contactUsFlowReducer';
import diagnostics from './diagnosticsReducer';
import featureFlags from './featureFlagsReducer';
import hubAccountPage from './hubAccountPageReducer';
import hubChangeGroupPage from './hubChangeGroupPageReducer';
import hubChangeSchedulePage from './hubChangeSchedulePageReducer';
import hubChangeSessionWithEnrolmentTutor from './hubChangeSessionWithEnrolmentTutorReducer';
import hubContactPage from './hubContactPageReducer';
import hubEnrolmentDetailPage from './hubEnrolmentDetailPageReducer';
import hubEnrolmentsPage from './hubEnrolmentsPageReducer';
import hubEnrolmentsWithResumeSession from './hubEnrolmentsWithResumeSessionReducer';
import hubSessionsPage from './hubSessionsPageReducer';
import hubUser from './hubUserReducer';
import login from './loginReducer';
import nextSession from './nextSessionReducer';
import report from './reportReducer';
import schoolsUpcomingSessions from './schoolsUpcomingSessionsReducer';
import studentProgress from './studentProgressReducer';
import summerMode from './summerModeReducer';
import triggerPayment from './triggerPaymentReducer';
import ui from './uiReducer';
import upcomingSessions from './upcomingSessionsReducer';
import zuora from './zuoraReducer';

const rootReducer = combineReducers({
  login,
  report,
  ui,
  diagnostics,
  activities,
  nextSession,
  upcomingSessions,
  contactUsFlow,
  triggerPayment,
  hubUser,
  hubSessionsPage,
  hubEnrolmentsPage,
  hubEnrolmentDetailPage,
  hubChangeGroupPage,
  hubChangeSchedulePage,
  hubAccountPage,
  hubContactPage,
  schoolsUpcomingSessions,
  studentProgress,
  hubEnrolmentsWithResumeSession,
  hubChangeSessionWithEnrolmentTutor,
  summerMode,
  zuora,
  featureFlags,
});

export default rootReducer;
